/*
Need to setup file association in the manifest as described here:
https://docs.microsoft.com/en-us/windows/uwp/launch-resume/handle-file-activation#step-3-handle-the-activated-event
*/

export default class Activation {
    public static register(gotTextCallback: (text: string) => void) {
        if (window.Windows) {
            Windows.UI.WebUI.WebUIApplication.addEventListener('activated',
                (activatedEventArgs: Windows.UI.WebUI.WebUIFileActivatedEventArgs) => {
                    if (activatedEventArgs.kind === Windows.ApplicationModel.Activation.ActivationKind.file) {
                        Windows.Storage.FileIO.readTextAsync(activatedEventArgs.files[0] as Windows.Storage.StorageFile)
                            .done((text: string) => {
                                if (gotTextCallback) {
                                    gotTextCallback(text);
                                }
                            });
                    }
                });
        }

    }
}
